import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const ProtectedDriverRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      console.log('🛡️ ProtectedDriverRoute: Checking authentication...');
      
      const { data: { user }, error } = await supabase?.auth?.getUser();

      if (error || !user) {
        console.log('❌ No authenticated user');
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      console.log('✅ User authenticated:', user?.email);

      // Verify employee exists
      const { data: employee, error: empError } = await supabase
        ?.from('employees')
        ?.select('id, is_active')
        ?.eq('auth_user_id', user?.id)
        ?.single();

      if (empError || !employee || !employee?.is_active) {
        console.log('❌ No valid employee record');
        setIsAuthenticated(false);
      } else {
        console.log('✅ Valid employee - access granted');
        setIsAuthenticated(true);
      }
    } catch (err) {
      console.error('❌ Auth check error:', err);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Vérification...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('🚫 Access denied - redirecting to login');
    return <Navigate to="/driver-login" replace />;
  }

  return children;
};

export default ProtectedDriverRoute;